<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
      Poczta nie wysłana - kopie robocze
    </h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Typ:</label>
        <multiselect-input v-model="form.type" :options="types" class="mt-1 w-full" track_by="key" opt_label="name_pl" :multiple="false" :close_on_select="true" />
        <label class="pt-4 block text-gray-700">Data wysyłki:</label>
        <text-input v-model="form.created_at" class="mt-1 w-full" type="date" />
      </search-filter>

    </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap text-xs">
          <tr class="text-left font-bold">
            <th class="px-3 pt-3 pb-4">Typ</th>
            <th class="px-3 pt-3 pb-4">Kontakt</th>
            <th class="px-3 pt-3 pb-4">Próba wysyłki</th>
            <th class="px-3 pt-3 pb-4">Treść błędu</th>
            <th class="px-3 pt-3 pb-4">Podgląd</th>
          </tr>
          <tr v-for="notification in notifications.data" :key="notification.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.drafts.preview', {'notification':notification.id})">
                {{ notification.typ.name_pl }}
              </inertia-link>
            </td>
            <td class="border-t">
              <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.drafts.preview', {'notification':notification.id})">
                {{ notification.notifiable.first_name }} {{ notification.notifiable.last_name }} &lt;{{ notification.notifiable.email }}&gt;
              </inertia-link>
            </td>
            <td class="border-t">
              <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.drafts.preview', {'notification':notification.id})">
                {{ notification.created_at }}
              </inertia-link>
            </td>
            <td class="border-t">
              <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.drafts.preview', {'notification':notification.id})">
                {{ notification.error_message }}
              </inertia-link>
            </td>
            <td class="border-t">
              <inertia-link class="px-3 py-2 flex items-center focus:text-shtax-500" :href="route('mailbox.drafts.preview', {'notification':notification.id})">
                <fa icon="eye" size="lg" fixed-width />
              </inertia-link>
            </td>
          </tr>
          <tr v-if="notifications.data.length === 0">
            <td class="border-t px-3 py-2" colspan="6">Brak nie wysłanych wiadomości.</td>
          </tr>
        </table>
      </div>

          <button class="btn-shtax mt-1" tabindex="-1" type="button" @click="update">Wyślij ponownie wszystkie</button>
    
    <pagination class="mt-3" :links="notifications.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import TextInput from '@/Shared/TextInput'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/ShtaxComponents/SearchFilter'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Skrzynka pocztowa - kopie robocze' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    MultiselectInput,
    TextInput,
    LoadingButton,
    ShtaxCheckbox
  },
  layout: Layout,
  props: {
    notifications: Object,
    filters: Object,
    types: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        created_at: this.filters.created_at,
        type: this.filters.type
      },
      form_tab: this.$inertia.form({
        _method: 'post'
      })
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('mailbox.drafts'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },

    update() {
      // console.log(this.form_tab.draft_ids)
      // console.log(this.form_tab)
      this.$inertia.post(this.route('mailbox.drafts.send_all'))
    },

  },

  // mounted() {
  //   console.log(this.notifications.data.map(notification => notification.id))
  // }

}
</script>
